const config = {
  apiKey: 'AIzaSyD1hoyFI5NRaPUlbVHQDyqQd3LXolD33nc',
  authDomain: 'theadmindoc.firebaseapp.com',
  databaseURL: 'https://theadmindoc.firebaseio.com',
  projectId: 'theadmindoc',
  storageBucket: 'theadmindoc.appspot.com',
  messagingSenderId: '1021338607426'
}

export default config



// WEBPACK FOOTER //
// ./src/admin/firebase_config/config.js